/**
 *
 * @param {*} name
 * Takes key name as input and returns the respective key from local storage
 * @returns {*} key
 */
const getSession = (name) => {
  return typeof window !== "undefined" ? sessionStorage.getItem(name) : null;
};

/**
 *
 * @param {*} name
 * @param {*} value
 * Takes key name and value as input and and stores the respective key value pair in local storage
 */
const setSession = (name, value) => {
  sessionStorage.setItem(name, value);
};

/**
 *
 * @param {*} name
 * Takes key name as input and removes the respective key from local storage
 */
const removeSession = (name) => {
  sessionStorage.removeItem(name);
};

/*
  Clear LocalStorage
  */
const clearSession = () => {
  sessionStorage.clear();
};
export { getSession, setSession, removeSession, clearSession };
